var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigure03Envelope01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8048 10.9182L44.8283 12.4263C44.8333 12.4664 44.8526 12.5032 44.8827 12.5299C44.9127 12.5566 44.9513 12.5713 44.9913 12.5713C45.0313 12.5713 45.0699 12.5566 45.0999 12.5299C45.1299 12.5032 45.1493 12.4664 45.1543 12.4263L45.1308 10.9182C45.1258 10.8781 45.1065 10.8413 45.0765 10.8146C45.0464 10.7879 45.0078 10.7732 44.9678 10.7732C44.9278 10.7732 44.8892 10.7879 44.8592 10.8146C44.8292 10.8413 44.8098 10.8781 44.8048 10.9182Z",
    fill: "#FEBDB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43814 5.39811L1.45991 23.4525C0.653623 26.3766 2.34893 29.4067 5.24648 30.2204L34.8257 38.5267C37.7233 39.3404 40.7258 37.6295 41.5321 34.7054L46.5104 16.6511C47.3166 13.7269 45.6213 10.6968 42.7238 9.88317L13.1445 1.57682C10.247 0.763136 7.24442 2.47399 6.43814 5.39811Z",
    fill: "#FEBDB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60088 26.5921L1.27747 25.8735L17.0463 18.6406L17.1872 19.0486C17.2054 19.1039 19.1041 24.4917 22.9016 25.4156C25.0351 25.942 27.4059 24.9523 29.9436 22.4992L30.4835 23.0704C27.7397 25.7209 25.1316 26.7684 22.7164 26.1815C19.1068 25.3024 17.1428 21.0595 16.6003 19.7119L1.60088 26.5921Z",
    fill: "#FC6663"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1658 23.2791L30.7928 22.8067L40.603 36.0695L39.976 36.5419L30.1658 23.2791Z",
    fill: "#FC6663"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2723 9.93636L13.6113 1.88487C10.8024 1.09525 8.54631 1.76643 7.79256 3.12194L7.36743 4.19846C7.7743 2.72713 10.3981 2.56921 13.2071 3.35619L41.8654 11.4077C44.6744 12.1973 46.62 14.0398 46.2158 15.5006L46.6226 14.0266C47.0399 12.5579 45.0812 10.7234 42.2723 9.93636Z",
    fill: "#FFDFB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46792 5.2946L1.48969 23.349C0.683408 26.2731 2.37871 29.3032 5.27626 30.1169L34.8555 38.4232C37.7531 39.2369 40.7556 37.526 41.5619 34.6019L46.5401 16.5475C47.3464 13.6234 45.6511 10.5933 42.7536 9.77965L13.1743 1.4733C10.2768 0.65962 7.27421 2.37047 6.46792 5.2946Z",
    stroke: "#242424",
    strokeWidth: 1.51376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58521 25.513L16.8689 18.438",
    stroke: "#242424",
    strokeWidth: 1.51376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8381 22.4651L40.6917 36.1887",
    stroke: "#242424",
    strokeWidth: 1.51376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36487 3.87732L19.6545 22.715C20.3116 23.8341 21.3719 24.6535 22.6137 25.0023C23.8555 25.351 25.1828 25.202 26.3183 24.5864L46.6853 14.7741",
    stroke: "#242424",
    strokeWidth: 1.51376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure03Envelope01);
export default __webpack_public_path__ + "static/media/figure_03_envelope_01.572e107d7a55cfedbeb0a4a92ac2ae44.svg";
export { ForwardRef as ReactComponent };